import React, { useEffect, useState } from "react";
import { enregistrerCommandePourEmploye } from "../services/commandes/CommandeRequest";
import {
    rechercherentreprises,
    recherchersiteparentreprise,
    rechercherSites,
} from "../services/entreprises/entrepriseRequest";
import { Autocomplete, TextField } from "@mui/material";
import { rechercherEmployeParSiteParEntreprise } from "../services/employes/EmployesRequest";
import { DecodeToken } from "../DecodeToken";
import { rechercherPlatsParRestaurantEtInstantEtEntrepriseEtSiteEtDate } from "../services/restauratrice/RestauratriceRequest";
import { returnImageLink } from "../vues/ReturnImageLink";

const ModalCommandeEmploye = ({ listeRestaurant, selectedEntreprise, onCommandeSuccess }) => {
    const [loadingHandler, setLoadingHandler] = useState(false);
    const [step, setStep] = useState(1);
    const [listeEntreprise, setListeEntreprise] = useState([]);
    const [listeSite, setListeSite] = useState([]);
    const [listeEmployes, setListeEmployes] = useState([]);
    const [listePlats, setListePlats] = useState([]);
    const [formFields, setFormFields] = useState({
        entrepriseId: "",
        siteId: "",
        employes: [],
        plats: [],
        restaurantId: "",
        memePlat: false,
        commandes: [],
        instant: "PETIT_DEJEUNER",
        date: "",
    });

    // State pour le step 2 - sélection individuelle
    const [step2Form, setStep2Form] = useState({
        selectedEmployeId: "",
        selectedPlats: [], // [{id, nom, prix, quantite}]
    });

    // States pour contrôler le texte des Autocomplete
    const [employeInputValueStep1, setEmployeInputValueStep1] = useState("");
    const [employeInputValueStep2, setEmployeInputValueStep2] = useState("");

    const rechercherSitesEntreprise = () => {
        rechercherSites()
            .then((response) => {
                setListeSite(response.data.donnee);
            })
            .catch(() => {
                console.log("++++ error sites");
            });
    };
    
    const rechercherSitesParEntrepriseId = (entrepriseId) => {
        recherchersiteparentreprise(entrepriseId)
            .then((response) => {
                setListeSite(response.data.donnee);
            })
            .catch(() => {
                console.log("++++ error sites");
            });
    };

    const rechercherListeEmployes = (entrepriseId, siteId) => {
        rechercherEmployeParSiteParEntreprise(entrepriseId, siteId)
            .then((response) => {
                setListeEmployes(response.data.donnee);
            })
            .catch(() => {
                console.log("++++ error employes");
            });
    };

    const rechercherListePlats = (
        restaurantId = 0,
        instant = "",
        entrepriseId = 0,
        siteId = 0,
        date = new Date()
    ) => {
        const dateFormatee = date
            ? new Date(date)
                .toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                .replace(/\//g, "-")
            : new Date()
                .toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                .replace(/\//g, "-");
        rechercherPlatsParRestaurantEtInstantEtEntrepriseEtSiteEtDate(
            restaurantId ? restaurantId : 0,
            instant ? instant : "",
            entrepriseId ? entrepriseId : 0,
            siteId ? siteId : 0,
            dateFormatee
        )
            .then((res) => {
                setListePlats(res.data.donnee);
            })
            .catch(() => {
                console.log("++++ error plats");
            });
    };

    const afficherEntreprise = () => {
        rechercherentreprises().then((response) => {
            setListeEntreprise(response.data.donnee);
        });
    };

    const handleCommandeForm = () => {
        setLoadingHandler(true);
        const data = {
            entrepriseId: formFields.entrepriseId,
            siteId: formFields.siteId,
            restaurantId: formFields.restaurantId,
            employesCommandes: formFields.commandes,
            instant: formFields.instant,
            date: new Date(formFields.date)
                .toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                .replace(/\//g, "-"),
        };

        enregistrerCommandePourEmploye(data)
            .then((response) => {
                setLoadingHandler(false);
                console.log(response.data.donnee);
                
                // Fermer la modal automatiquement après succès
                const closeButton = document.querySelector('#commandeEmploye .btn-close');
                if (closeButton) {
                    closeButton.click();
                }
                
                // Déclencher le rafraîchissement des données dans le composant parent
                if (onCommandeSuccess && typeof onCommandeSuccess === 'function') {
                    onCommandeSuccess();
                }
                
                // Réinitialiser le formulaire
                setFormFields({
                    entrepriseId: selectedEntreprise ? selectedEntreprise.id : "",
                    siteId: "",
                    employes: [],
                    plats: [],
                    restaurantId: "",
                    memePlat: false,
                    commandes: [],
                    instant: "PETIT_DEJEUNER",
                    date: "",
                });
                setStep2Form({
                    selectedEmployeId: "",
                    selectedPlats: [],
                });
                setEmployeInputValueStep1("");
                setEmployeInputValueStep2("");
                setStep(1);
            })
            .catch(() => {
                setLoadingHandler(false);
            });
    };

    useEffect(() => {
        if (selectedEntreprise) {
            setFormFields({
                ...formFields,
                entrepriseId: selectedEntreprise.id,
            });
        }
        if (DecodeToken().profil === "ROLE_ADMIN") {
            afficherEntreprise();
        }
        if (DecodeToken().profil !== "ROLE_ADMIN") {
            rechercherSitesEntreprise();    
        }
    }, []);

    return (
        <div>
            {/* Step 1 */}
            {step === 1 && (
                <div>
                    {DecodeToken().profil === "ROLE_ADMIN" && (
                        <div className="mb-3">
                            <label
                                htmlFor="entrepriseId"
                                className="form-label fw-medium mb-0"
                            >
                                Entreprise
                            </label>
                            <select
                                className="form-control"
                                style={{ backgroundColor: "#f5f5f5" }}
                                id="entrepriseId"
                                value={formFields.entrepriseId}
                                onChange={(e) => {
                                    rechercherListeEmployes(e.target.value, formFields.siteId);
                                    rechercherSitesParEntrepriseId(e.target.value);
                                    rechercherListePlats(
                                        formFields.restaurantId,
                                        formFields.instant,
                                        e.target.value,
                                        formFields.siteId,
                                        formFields.date
                                    );
                                    setFormFields({
                                        ...formFields,
                                        entrepriseId: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Sélectionnez une entreprise</option>
                                {listeEntreprise.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.raisonSociale}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <div className="w-50 mb-2">
                            <label
                                htmlFor="entrepriseId"
                                className="form-label fw-medium mb-0"
                            >
                                Site de l'entreprise
                            </label>
                            <select
                                className="form-control"
                                style={{ backgroundColor: "#f5f5f5" }}
                                id="entrepriseId"
                                value={formFields.siteId}
                                onChange={(e) => {
                                    rechercherListeEmployes(
                                        formFields.entrepriseId ? formFields.entrepriseId : 0,
                                        e.target.value
                                    );
                                    rechercherListePlats(
                                        formFields.restaurantId,
                                        formFields.instant,
                                        formFields.entrepriseId,
                                        e.target.value,
                                        formFields.date
                                    );
                                    setFormFields({
                                        ...formFields,
                                        siteId: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Sélectionnez un site</option>
                                {listeSite.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.nom}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="w-50 mb-2">
                            <label
                                htmlFor="entrepriseId"
                                className="form-label fw-medium mb-0"
                            >
                                Restaurant
                            </label>
                            <select
                                className="form-control"
                                style={{ backgroundColor: "#f5f5f5" }}
                                id="entrepriseId"
                                value={formFields.restaurantId}
                                onChange={(e) => {
                                    rechercherListePlats(
                                        e.target.value,
                                        formFields.instant,
                                        formFields.entrepriseId,
                                        formFields.siteId,
                                        formFields.date
                                    );
                                    setFormFields({
                                        ...formFields,
                                        restaurantId: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Sélectionnez un restaurant</option>
                                {listeRestaurant &&
                                    listeRestaurant.length > 0 &&
                                    listeRestaurant.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.nom}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="w-50 mb-2">
                            <label
                                htmlFor="entrepriseId"
                                className="form-label fw-medium mb-0"
                            >
                                Instant de restauration
                            </label>
                            <select
                                className="form-control"
                                style={{ backgroundColor: "#f5f5f5" }}
                                id="entrepriseId"
                                value={formFields.instant}
                                onChange={(e) => {
                                    rechercherListePlats(
                                        formFields.restaurantId,
                                        e.target.value,
                                        formFields.entrepriseId,
                                        formFields.siteId,
                                        formFields.date
                                    );
                                    setFormFields({
                                        ...formFields,
                                        instant: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Sélectionnez une période</option>
                                <option value="PETIT_DEJEUNER">Petit déjeuner</option>
                                <option value="DEJEUNER">Déjeuner</option>
                                <option value="DINER">Diner</option>
                            </select>
                        </div>

                        <div className="w-50 mb-2">
                            <label
                                htmlFor="entrepriseId"
                                className="form-label fw-medium mb-0"
                            >
                                Date
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                style={{ backgroundColor: "#f5f5f5" }}
                                id="entrepriseId"
                                value={formFields.date}
                                onChange={(e) => {
                                    rechercherListePlats(
                                        formFields.restaurantId,
                                        formFields.instant,
                                        formFields.entrepriseId,
                                        formFields.siteId,
                                        e.target.value
                                    );
                                    setFormFields({
                                        ...formFields,
                                        date: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="mb-3">
                        <Autocomplete
                            disablePortal
                            id="employeSelect"
                            options={(() => {
                                const employesDisponibles = listeEmployes.filter(
                                    (item) => !formFields.employes.some((emp) => emp.id === item.id)
                                );
                                
                                // Ajouter l'option "Tous les employés" seulement s'il y a des employés disponibles
                                if (employesDisponibles.length > 1) {
                                    return [
                                        { id: "ALL", nom: "Sélectionner tous les employés", isSpecialOption: true },
                                        ...employesDisponibles
                                    ];
                                }
                                return employesDisponibles;
                            })()}
                            getOptionLabel={(option) => option.nom ?? option}
                            value={null}
                            inputValue={employeInputValueStep1}
                            onInputChange={(event, newInputValue) => {
                                setEmployeInputValueStep1(newInputValue);
                            }}
                            onChange={(event, value) => {
                                if (value) {
                                    if (value.isSpecialOption && value.id === "ALL") {
                                        // Sélectionner tous les employés disponibles
                                        const employesDisponibles = listeEmployes.filter(
                                            (item) => !formFields.employes.some((emp) => emp.id === item.id)
                                        );
                                        setFormFields({
                                            ...formFields,
                                            employes: [...formFields.employes, ...employesDisponibles],
                                        });
                                    } else {
                                        // Sélection normale d'un employé
                                        setFormFields({
                                            ...formFields,
                                            employes: [...formFields.employes, value],
                                        });
                                    }
                                    // Effacer le texte après sélection
                                    setEmployeInputValueStep1("");
                                }
                            }}
                            sx={{ width: "100%" }}
                            size="small"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Sélectionnez un employé"
                                    style={{ backgroundColor: "#f5f5f5" }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} style={{
                                    fontWeight: option.isSpecialOption ? 'bold' : 'normal',
                                    color: option.isSpecialOption ? '#CE5D1D' : 'inherit',
                                    borderBottom: option.isSpecialOption ? '1px solid #eee' : 'none',
                                    marginBottom: option.isSpecialOption ? '4px' : '0'
                                }}>
                                    {option.isSpecialOption && <i className="bi bi-plus me-2"></i>}
                                    {option.nom} {option.prenoms}
                                </li>
                            )}
                        />
                    </div>

                    {formFields.employes.length > 0 && (
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="mb-0 fw-bold text-muted" style={{ fontSize: 14 }}>
                                Employés sélectionnés ({formFields.employes.length})
                            </p>
                            <button
                                className="btn btn-sm btn-outline-danger d-flex align-items-center gap-2"
                                onClick={() => {
                                    // Vérifier s'il y a des employés avec des commandes
                                    const employesAvecCommandes = formFields.employes.filter(emp => 
                                        formFields.commandes.some(cmd => cmd.employeId === emp.id)
                                    );
                                    
                                    if (employesAvecCommandes.length > 0) {
                                        const nomsEmployes = employesAvecCommandes.map(emp => emp.nom).join(', ');
                                        alert(`Impossible de supprimer tous les employés car des commandes ont été configurées pour : ${nomsEmployes}. Veuillez d'abord supprimer leurs commandes.`);
                                        return;
                                    }
                                    
                                    // Supprimer tous les employés s'il n'y a pas de commandes
                                    setFormFields({
                                        ...formFields,
                                        employes: []
                                    });
                                }}
                                title="Supprimer tous les employés"
                            >
                                <i className="bi bi-trash-fill"></i>
                                Tout supprimer
                            </button>
                        </div>
                    )}

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: 10,
                        }}
                    >
                        {formFields.employes.map((item) => (
                            <div
                                key={item.id}
                                className="d-flex justify-content-between align-items-center p-2 rounded-3"
                                style={{ backgroundColor: "#f5f5f5" }}
                            >
                                <div className="d-flex align-items-center gap-2">
                                    <div
                                        className="rounded-circle bg-white d-flex justify-content-center align-items-center"
                                        style={{ width: 40, height: 40 }}
                                    >
                                        EN
                                    </div>
                                    <div className="d-flex flex-column">
                                        <p className="mb-0 fw-bold" style={{ fontSize: 14 }}>
                                            {item.nom} {item.prenoms}
                                        </p>
                                        <p className="mb-0 text-muted" style={{ fontSize: 12 }}>
                                            {item.email}
                                        </p>
                                    </div>
                                </div>
                                {(() => {
                                    const aUneCommande = formFields.commandes.some(
                                        (cmd) => cmd.employeId === item.id
                                    );
                                    return (
                                        <button
                                            className={`btn btn-sm text-white d-flex justify-content-center align-items-center ${aUneCommande ? "btn-secondary" : "btn-danger"
                                                }`}
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: aUneCommande ? "not-allowed" : "pointer",
                                                opacity: aUneCommande ? 0.6 : 1,
                                            }}
                                            onClick={() => {
                                                if (aUneCommande) {
                                                    alert(
                                                        "Impossible de supprimer cet employé car une commande a déjà été configurée pour lui. Veuillez d'abord supprimer sa commande."
                                                    );
                                                    return;
                                                }
                                                setFormFields({
                                                    ...formFields,
                                                    employes: formFields.employes.filter(
                                                        (e) => e.id !== item.id
                                                    ),
                                                });
                                            }}
                                            title={
                                                aUneCommande
                                                    ? "Impossible de supprimer - commande configurée"
                                                    : "Supprimer l'employé"
                                            }
                                        >
                                            <i
                                                className={`bi ${aUneCommande ? "bi-lock-fill" : "bi-trash-fill"
                                                    }`}
                                            ></i>
                                        </button>
                                    );
                                })()}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Step 2 */}
            {step === 2 && (
                <div className="d-flex align-items-start gap-3">
                    <div className="w-50">
                        <div className="mb-3">
                            <label className="label-control d-flex align-items-center gap-1">
                                <input
                                    type="checkbox"
                                    name="processCommande"
                                    id="processCommande"
                                    checked={formFields.memePlat}
                                    onChange={(e) => {
                                        setFormFields({
                                            ...formFields,
                                            memePlat: e.target.checked,
                                            commandes: [], // Vider les commandes quand on change de mode
                                            plats: [], // Vider aussi la sélection de plats
                                        });
                                        // Reset aussi la sélection individuelle
                                        setStep2Form({
                                            selectedEmployeId: "",
                                            selectedPlats: [],
                                        });
                                        // Reset aussi le texte de l'autocomplete
                                        setEmployeInputValueStep2("");
                                    }}
                                />
                                Même plat pour tous les employés
                            </label>
                        </div>

                        {!formFields.memePlat && (
                            <div className="mb-3">
                                <label
                                    htmlFor="selectEmployeStep2"
                                    className="form-label fw-medium mb-0"
                                >
                                    Employés
                                </label>
                                <Autocomplete
                                    disablePortal
                                    id="selectEmployeStep2"
                                    options={formFields.employes.filter(
                                        (emp) =>
                                            !formFields.commandes.some(
                                                (cmd) => cmd.employeId === emp.id
                                            )
                                    )}
                                    getOptionLabel={(option) => option.nom + " " + option.prenoms ?? option}
                                    value={
                                        formFields.employes.find(
                                            (emp) => emp.id === parseInt(step2Form.selectedEmployeId)
                                        ) || null
                                    }
                                    inputValue={employeInputValueStep2}
                                    onInputChange={(event, newInputValue) => {
                                        setEmployeInputValueStep2(newInputValue);
                                    }}
                                    onChange={(event, value) => {
                                        setStep2Form({
                                            ...step2Form,
                                            selectedEmployeId: value ? value.id.toString() : "",
                                            selectedPlats: [], // Reset plats selection when changing employee
                                        });
                                        // Effacer le texte après sélection
                                        setEmployeInputValueStep2("");
                                    }}
                                    sx={{ width: "100%" }}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            style={{ backgroundColor: "#f5f5f5" }}
                                        />
                                    )}
                                />
                            </div>
                        )}

                        <div className="mt-3">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="mb-1 fw-bold text-rose" style={{ fontSize: 18 }}>
                                    Liste des plats
                                </p>
                                {((!formFields.memePlat &&
                                    step2Form.selectedEmployeId &&
                                    step2Form.selectedPlats.length > 0) ||
                                    (formFields.memePlat &&
                                        formFields.plats.length > 0 &&
                                        formFields.employes.filter(
                                            (emp) =>
                                                !formFields.commandes.some(
                                                    (cmd) => cmd.employeId === emp.id
                                                )
                                        ).length > 0)) && (
                                        <button
                                            className="btn btn-sm btn-rose text-white d-flex justify-content-center align-items-center"
                                            onClick={() => {
                                                if (formFields.memePlat) {
                                                    // Mode "même plat pour tous" - créer une commande pour chaque employé qui n'en a pas déjà une
                                                    const employesSansCommande = formFields.employes.filter(
                                                        (employe) =>
                                                            !formFields.commandes.some(
                                                                (cmd) => cmd.employeId === employe.id
                                                            )
                                                    );

                                                    const newCommandes = employesSansCommande.map(
                                                        (employe) => ({
                                                            employeId: employe.id,
                                                            commandes: formFields.plats.map((plat) => ({
                                                                repasId: plat.id,
                                                                quantite: 1, // Quantité par défaut pour le mode "même plat pour tous"
                                                            })),
                                                        })
                                                    );

                                                    // Ajouter toutes les commandes
                                                    setFormFields({
                                                        ...formFields,
                                                        commandes: [...formFields.commandes, ...newCommandes],
                                                        plats: [], // Reset la sélection de plats
                                                    });
                                                } else {
                                                    // Mode individuel - créer une commande pour l'employé sélectionné
                                                    const newCommande = {
                                                        employeId: parseInt(step2Form.selectedEmployeId),
                                                        commandes: step2Form.selectedPlats.map((plat) => ({
                                                            repasId: plat.id,
                                                            quantite: plat.quantite || 1,
                                                        })),
                                                    };

                                                    // Ajouter à la liste des commandes
                                                    setFormFields({
                                                        ...formFields,
                                                        commandes: [...formFields.commandes, newCommande],
                                                    });

                                                    // Reset la sélection
                                                    setStep2Form({
                                                        selectedEmployeId: "",
                                                        selectedPlats: [],
                                                    });
                                                }
                                            }}
                                        >
                                            Enregistrer la selection
                                        </button>
                                    )}
                            </div>
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    gap: 10,
                                    maxHeight: 420,
                                    overflowY: "auto",
                                }}
                            >
                                {listePlats.length > 0 &&
                                    listePlats.map((item, index) => (
                                        <div
                                            key={index}
                                            className="d-flex justify-content-between align-items-center p-2 rounded-3"
                                            style={{
                                                backgroundColor: "#f5f5f5",
                                                cursor:
                                                    !formFields.memePlat && !step2Form.selectedEmployeId
                                                        ? "not-allowed"
                                                        : "pointer",
                                                opacity:
                                                    !formFields.memePlat && !step2Form.selectedEmployeId
                                                        ? 0.5
                                                        : 1,
                                                border: (
                                                    formFields.memePlat
                                                        ? formFields.plats.some((p) => p.id === item.id)
                                                        : step2Form.selectedPlats.some(
                                                            (p) => p.id === item.id
                                                        )
                                                )
                                                    ? "2px solid #CE5D1D"
                                                    : "none",
                                            }}
                                            onClick={() => {
                                                if (formFields.memePlat) {
                                                    setFormFields({
                                                        ...formFields,
                                                        plats: formFields.plats.some(
                                                            (p) => p.id === item.id
                                                        )
                                                            ? formFields.plats.filter((p) => p.id !== item.id)
                                                            : [...formFields.plats, item],
                                                    });
                                                } else {
                                                    // Vérifier qu'un employé est sélectionné en mode individuel
                                                    if (!step2Form.selectedEmployeId) {
                                                        alert(
                                                            "Veuillez d'abord sélectionner un employé avant de choisir des plats."
                                                        );
                                                        return;
                                                    }
                                                    setStep2Form({
                                                        ...step2Form,
                                                        selectedPlats: step2Form.selectedPlats.some(
                                                            (p) => p.id === item.id
                                                        )
                                                            ? step2Form.selectedPlats.filter(
                                                                (p) => p.id !== item.id
                                                            )
                                                            : [
                                                                ...step2Form.selectedPlats,
                                                                { ...item, quantite: 1 },
                                                            ],
                                                    });
                                                }
                                            }}
                                        >
                                            <div className="d-flex align-items-start gap-2">
                                                <div
                                                    className="rounded-3 bg-white d-flex justify-content-center align-items-center"
                                                    style={{ width: 40, height: 40 }}
                                                >
                                                    {item.visuel ? (
                                                        <img
                                                            src={returnImageLink(item.visuel)}
                                                            alt="plat"
                                                            style={{ width: "100%", height: "100%" }}
                                                        />
                                                    ) : (
                                                        <i className="bi bi-image"></i>
                                                    )}
                                                </div>
                                                <div
                                                    className="d-flex flex-column"
                                                    style={{ width: "80%" }}
                                                >
                                                    <p
                                                        className="mb-0 fw-bold"
                                                        style={{
                                                            fontSize: 14,
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                        }}
                                                    >
                                                        {item.designation}
                                                    </p>
                                                    <p
                                                        className="mb-0 text-muted"
                                                        style={{ fontSize: 12 }}
                                                    >
                                                        {item.prix} FCFA
                                                    </p>
                                                    {!formFields.memePlat &&
                                                        step2Form.selectedPlats.some(
                                                            (p) => p.id === item.id
                                                        ) && (
                                                            <div className="d-flex align-items-center gap-2 mt-2">
                                                                <span
                                                                    className="text-muted"
                                                                    style={{ fontSize: 12, fontWeight: 500 }}
                                                                >
                                                                    Quantité
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={
                                                                        step2Form.selectedPlats.find(
                                                                            (p) => p.id === item.id
                                                                        )?.quantite || 1
                                                                    }
                                                                    onChange={(e) => {
                                                                        const quantite =
                                                                            parseInt(e.target.value) || 1;
                                                                        setStep2Form({
                                                                            ...step2Form,
                                                                            selectedPlats:
                                                                                step2Form.selectedPlats.map((p) =>
                                                                                    p.id === item.id
                                                                                        ? { ...p, quantite }
                                                                                        : p
                                                                                ),
                                                                        });
                                                                    }}
                                                                    min="1"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    style={{
                                                                        width: "60px",
                                                                        height: 25,
                                                                        borderRadius: 5,
                                                                        fontSize: 12,
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            {listePlats.length === 0 && (
                                <div
                                    className="w-100 d-flex flex-column align-items-center justify-content-center"
                                    style={{ width: "100%", height: 150, backgroundColor: "#f5f5f5" }}
                                >
                                    <i
                                        className="bi bi-info-circle"
                                        style={{ fontSize: 20, color: "#CE5D1D" }}
                                    ></i>
                                    <p
                                        className="mb-0 text-danger"
                                        style={{ fontSize: 14, fontWeight: 500 }}
                                    >
                                        Aucun plat trouvé
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex flex-column gap-2 w-50">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="fw-bold text-rose text-center">
                                Liste des commandes
                            </p>
                            <div>
                                <p>
                                    Montant total :{" "}
                                    <span className="fw-bold text-rose">
                                        {formFields.commandes
                                            .reduce((acc, cmd) => {
                                                return (
                                                    acc +
                                                    cmd.commandes.reduce((platAcc, plat) => {
                                                        // Trouver le plat correspondant dans la liste des plats pour obtenir son prix
                                                        const platInfo = listePlats.find(
                                                            (p) => p.id === plat.repasId
                                                        );
                                                        const prix = platInfo ? platInfo.prix : 0;
                                                        return platAcc + plat.quantite * prix;
                                                    }, 0)
                                                );
                                            }, 0)
                                            .toLocaleString()}{" "}
                                        FCFA
                                    </span>
                                </p>
                            </div>
                        </div>
                        {formFields.commandes.length > 0 && (
                            <div
                                className="d-flex flex-column gap-3"
                                style={{ maxHeight: 530, overflowY: "auto" }}
                            >
                                {formFields.commandes.map((commande, index) => {
                                    const employe = listeEmployes.find(
                                        (emp) => emp.id === commande.employeId
                                    );
                                    return (
                                        <div
                                            key={index}
                                            className="position-relative"
                                            style={{
                                                backgroundColor: "#f5f5f5",
                                                borderRadius: 5,
                                                padding: 10,
                                                border: "1px solid #dfdfdf",
                                            }}
                                        >
                                            <div
                                                className="position-absolute"
                                                style={{ top: 10, right: 10 }}
                                            >
                                                <button
                                                    className="btn btn-sm btn-danger text-white d-flex justify-content-center align-items-center"
                                                    style={{ width: 30, height: 30 }}
                                                    onClick={() => {
                                                        setFormFields({
                                                            ...formFields,
                                                            commandes: formFields.commandes.filter(
                                                                (_, i) => i !== index
                                                            ),
                                                        });
                                                    }}
                                                >
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </div>

                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <div
                                                    className="rounded-3 bg-white d-flex justify-content-center align-items-center"
                                                    style={{ width: 40, height: 40 }}
                                                >
                                                    {employe?.nom
                                                        .split(" ")
                                                        .map((n) => n[0])
                                                        .join("")
                                                        .toUpperCase() || "EN"}
                                                </div>
                                                <div>
                                                    <p className="mb-0 fw-bold" style={{ fontSize: 14 }}>
                                                        {`${employe?.nom} ${employe?.prenoms}` || "Employé inconnu"}
                                                    </p>
                                                    <p
                                                        className="mb-0 text-muted"
                                                        style={{ fontSize: 12 }}
                                                    >
                                                        {employe?.email || ""}
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                className=""
                                                style={{
                                                    width: "100%",
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                    gap: 10,
                                                }}
                                            >
                                                {commande.commandes.map((platCommande, platIndex) => {
                                                    const plat = listePlats.find(
                                                        (p) => p.id === platCommande.repasId
                                                    );
                                                    return (
                                                        <div
                                                            key={platIndex}
                                                            className="d-flex flex-column align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: "#fff",
                                                                width: "fit-content",
                                                                border: "1px solid #fafafa",
                                                                borderRadius: 8,
                                                                padding: 6,
                                                                boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
                                                            }}
                                                        >
                                                            <div className="d-flex align-items-start gap-2">
                                                                <div
                                                                    style={{
                                                                        width: 30,
                                                                        height: 30,
                                                                        backgroundColor: "#f5f5f5",
                                                                        borderRadius: 3,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: 12,
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    {plat?.id || "?"}
                                                                </div>
                                                                <div style={{ width: "80%" }}>
                                                                    <p
                                                                        className="fw-bold text-left"
                                                                        style={{ fontSize: 12 }}
                                                                    >
                                                                        {plat?.designation || "Plat inconnu"} (
                                                                        {plat?.prix || 0} FCFA)
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className=""
                                                                style={{ width: "100%", marginTop: -5 }}
                                                            >
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={platCommande.quantite}
                                                                    onChange={(e) => {
                                                                        const nouvelleQuantite =
                                                                            parseInt(e.target.value) || 1;
                                                                        const nouvellesCommandes = [
                                                                            ...formFields.commandes,
                                                                        ];
                                                                        nouvellesCommandes[index].commandes[
                                                                            platIndex
                                                                        ].quantite = nouvelleQuantite;
                                                                        setFormFields({
                                                                            ...formFields,
                                                                            commandes: nouvellesCommandes,
                                                                        });
                                                                    }}
                                                                    min="1"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: 23,
                                                                        borderRadius: 3,
                                                                        fontSize: 12,
                                                                        padding: "0px 5px",
                                                                        backgroundColor: "#F1F1F1",
                                                                        textAlign: "center",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        {formFields.commandes.length === 0 && (
                            <div
                                className="d-flex flex-column align-items-center justify-content-center"
                                style={{ height: 300 }}
                            >
                                <i
                                    className="bi bi-info-circle"
                                    style={{ fontSize: 20, color: "#CE5D1D" }}
                                ></i>
                                <p
                                    className="mb-0 text-danger"
                                    style={{ fontSize: 14, fontWeight: 500 }}
                                >
                                    Aucune commande configurée
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <div className="mt-4 d-flex justify-content-end gap-2">
                {step > 1 && (
                    <button
                        disabled={loadingHandler}
                        onClick={() => setStep(step - 1)}
                        className="btn btn-md fw-bold btn-secondary text-white"
                    >
                        Retour
                    </button>
                )}
                {step === 1 && (
                    <button
                        disabled={
                            formFields.siteId === "" ||
                            formFields.restaurantId === "" ||
                            formFields.instant === "" ||
                            formFields.employes.length === 0
                        }
                        onClick={() => setStep(step + 1)}
                        className="btn btn-md fw-bold btn-rose text-white"
                    >
                        Suivant
                    </button>
                )}
                {step === 2 && (
                    <button
                        onClick={handleCommandeForm}
                        disabled={formFields.commandes.length === 0 || loadingHandler}
                        className={`btn btn-md fw-bold text-white ${formFields.commandes.length === 0 || loadingHandler
                            ? "btn-secondary"
                            : "btn-rose"
                            }`}
                        style={{
                            cursor:
                                formFields.commandes.length === 0 || loadingHandler
                                    ? "not-allowed"
                                    : "pointer",
                            opacity:
                                formFields.commandes.length === 0 || loadingHandler ? 0.6 : 1,
                        }}
                        title={
                            formFields.commandes.length === 0
                                ? "Aucune commande configurée"
                                : loadingHandler
                                    ? "Enregistrement en cours..."
                                    : "Enregistrer les commandes"
                        }
                    >
                        {loadingHandler ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Enregistrement...
                            </>
                        ) : (
                            "Enregistrer les commandes"
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ModalCommandeEmploye;
